var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-col",
    {
      staticClass: "before-32",
      class: { "insetx-16": _vm.$media.l, "insetx-4": _vm.$media.s },
      attrs: { id: "search-res" },
    },
    [
      _c(
        "ib-row",
        { staticClass: "flex-flex" },
        [
          _c(
            "ib-col",
            [
              _c("CurrencySelector", {
                attrs: { hideInfo: "" },
                on: { update: _vm.update },
              }),
            ],
            1
          ),
          _c(
            "ib-col",
            { staticClass: "text-right" },
            [
              _c(
                "ib-button",
                {
                  staticClass: "dark-grey-text fw-400 fs6 menu-body",
                  on: { click: _vm.startOver },
                },
                [_vm._v(_vm._s(_vm.$t("start_over")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.groups, function (group, index) {
        return _c("div", { key: index }, [
          _vm.getSelected(group.companies) !== 0
            ? _c(
                "div",
                [
                  _c(
                    "ib-row",
                    [
                      _c("ib-col", [
                        _c("p", { staticClass: "bold" }, [
                          _vm._v(
                            _vm._s(_vm.$t("group")) + " " + _vm._s(index + 1)
                          ),
                        ]),
                        _c("div", {
                          staticClass: "after-12 border-bottom bg-gray80",
                        }),
                        _c("div", { staticClass: "after-16" }, [
                          _c("span", { staticClass: "after-16" }, [
                            _vm._v(_vm._s(_vm.$t("ticker_symbol")) + ": "),
                            _c(
                              "span",
                              {
                                staticClass: "fg-primary",
                                attrs: {
                                  title: group.companies
                                    .filter(function (comp) {
                                      return comp.selected
                                    })
                                    .map(function (comp) {
                                      return comp.ticker
                                    })
                                    .join(", "),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    group.companies
                                      .filter(function (comp) {
                                        return comp.selected
                                      })
                                      .map(function (comp) {
                                        return comp.ticker
                                      })
                                      .join(", ")
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c("p", { staticClass: "after-16" }, [
                          _vm._v(
                            _vm._s(_vm.$t("showing")) +
                              " " +
                              _vm._s(_vm.getSelected(group.companies)) +
                              " " +
                              _vm._s(_vm.$t("of")) +
                              " " +
                              _vm._s(_vm.getSelected(group.companies))
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "ib-row",
                    { staticClass: "after_table" },
                    [
                      _c(
                        "ib-col",
                        {
                          staticClass: "scroll flex after-8",
                          staticStyle: { "max-height": "65vh" },
                        },
                        [
                          _c(
                            "ib-table-basic",
                            {
                              staticClass: "fs7 fg70 shrink fin-table",
                              staticStyle: {
                                border: "1px solid rgba(0,0,0,0.15)",
                                "overscroll-behavior": "contain",
                              },
                              attrs: {
                                data: _vm.selectedGroup(index),
                                row: "",
                                colborder: "",
                                rowstripe: "",
                                spacing: "huge",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "body",
                                    fn: function (company) {
                                      return [
                                        !_vm.$media.xl
                                          ? _c(
                                              "td",
                                              { staticClass: "padding-zero" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "info results",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showResultModal(
                                                          company
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          viewBox: "0 0 13 13",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M6.5 0A6.5 6.5 0 1013 6.5 6.5 6.5 0 006.5 0z",
                                                          },
                                                        }),
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M6.5 2.543a.848.848 0 10.848.848.848.848 0 00-.848-.848zM5.37 5.37v.565h.565v3.674H5.37v.565h2.26v-.565h-.565V5.37z",
                                                            fill: "#fff",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "row_tracker",
                                            attrs: {
                                              "data-conid": company["conid"],
                                              title: _vm.formatComp(
                                                company["company"]
                                              ),
                                            },
                                            on: { click: _vm.getMoreInfo },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatComp(
                                                  company["company"]
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            attrs: { title: company["ticker"] },
                                            on: {
                                              click: function ($event) {
                                                return _vm.getMoreDetails(
                                                  company["company"],
                                                  company["conid"]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "fg-accent" },
                                              [
                                                _vm._v(
                                                  _vm._s(company["ticker"])
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("td", {
                                          attrs: {
                                            title: company["company_cntry"],
                                          },
                                          domProps: {
                                            textContent: _vm._s(
                                              company["company_cntry"]
                                            ),
                                          },
                                          on: { click: _vm.getMoreInfo },
                                        }),
                                        _c("td", {
                                          attrs: { title: company["industry"] },
                                          domProps: {
                                            textContent: _vm._s(
                                              company["industry"]
                                            ),
                                          },
                                          on: { click: _vm.getMoreInfo },
                                        }),
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              title: company["conv_price"],
                                            },
                                            on: { click: _vm.getMoreInfo },
                                          },
                                          [
                                            !company["conv_price"]
                                              ? _c("div", {
                                                  staticClass: "spin",
                                                })
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-right weighted",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        company["conv_price"]
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: {
                                              title: _vm.getFormat(
                                                company["conv_mkt_cap"]
                                              ),
                                            },
                                            on: { click: _vm.getMoreInfo },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getFormat(
                                                  company["conv_mkt_cap"]
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: {
                                              title: _vm.getFormat(
                                                company["conv_ev_cur"]
                                              ),
                                            },
                                            on: { click: _vm.getMoreInfo },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getFormat(
                                                  company["conv_ev_cur"]
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: {
                                              title: _vm.setExchRev(
                                                company["ttmrev"]
                                              ),
                                            },
                                            on: { click: _vm.getMoreInfo },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.setExchRev(
                                                  company["ttmrev"]
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: {
                                              title: _vm.setExchNI(
                                                company["ttmebitd"]
                                              ),
                                            },
                                            on: { click: _vm.getMoreInfo },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.setExchNI(
                                                  company["ttmebitd"]
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: {
                                              title: _vm.getGrowth(
                                                company["epsgrpct"]
                                              ),
                                            },
                                            on: { click: _vm.getMoreInfo },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getGrowth(
                                                  company["epsgrpct"]
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: {
                                              title: _vm.getYield(
                                                company["divyield"]
                                              ),
                                            },
                                            on: { click: _vm.getMoreInfo },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getYield(
                                                  company["divyield"]
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: {
                                              title: _vm.getFixed(
                                                company["peexclxor"]
                                              ),
                                            },
                                            on: { click: _vm.getMoreInfo },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getFixed(
                                                  company["peexclxor"]
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: {
                                              title: _vm.getRatio(
                                                company["peg"]
                                              ),
                                            },
                                            on: { click: _vm.getMoreInfo },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getRatio(company["peg"])
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              !_vm.$media.xl
                                ? _c(
                                    "ib-table-col",
                                    { attrs: { width: "3ch", sticky: "" } },
                                    [
                                      _c("div", {
                                        staticClass: "border-bottom",
                                      }),
                                      _c("div", [
                                        _c("span", {
                                          staticClass: "weighted text-right",
                                        }),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "ib-table-col",
                                { attrs: { width: "14ch", sticky: "" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "border-bottom",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.sortResults(
                                            "company",
                                            "",
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: {
                                            title: _vm.$t("company_name"),
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("company_name")))]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "up",
                                          class: {
                                            "active-sort":
                                              _vm.previousSort.type ===
                                                "company" &&
                                              _vm.previousSort.dir === "asc" &&
                                              _vm.previousSort.index === index,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.sortResults(
                                                "company",
                                                "asc",
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            { attrs: { viewBox: "0 0 50 50" } },
                                            [
                                              _c("path", {
                                                attrs: { d: "M25 13L4 35h42z" },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "down",
                                          class: {
                                            "active-sort":
                                              _vm.previousSort.type ===
                                                "company" &&
                                              _vm.previousSort.dir === "desc" &&
                                              _vm.previousSort.index === index,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.sortResults(
                                                "company",
                                                "desc",
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            { attrs: { viewBox: "0 0 50 50" } },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M4 17l21 22 21-22z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("div", [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          title: _vm.$t("weighted_average"),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("weighted_average"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _c("ib-table-col", { attrs: { width: "8ch" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "border-bottom",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.sortResults(
                                          "ticker",
                                          "",
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { title: _vm.$t("ticker") } },
                                      [_vm._v(_vm._s(_vm.$t("ticker")))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "up",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "ticker" &&
                                            _vm.previousSort.dir === "asc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "ticker",
                                              "asc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: { d: "M25 13L4 35h42z" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "down",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "ticker" &&
                                            _vm.previousSort.dir === "desc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "ticker",
                                              "desc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M4 17l21 22 21-22z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "weighted text-right" },
                                    [_vm._v("-")]
                                  ),
                                ]),
                              ]),
                              _c("ib-table-col", { attrs: { width: "10ch" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "border-bottom",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.sortResults(
                                          "country",
                                          "",
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { title: _vm.$t("country") } },
                                      [_vm._v(_vm._s(_vm.$t("country")))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "up",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "country" &&
                                            _vm.previousSort.dir === "asc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "country",
                                              "asc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: { d: "M25 13L4 35h42z" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "down",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "country" &&
                                            _vm.previousSort.dir === "desc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "country",
                                              "desc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M4 17l21 22 21-22z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "weighted text-right" },
                                    [_vm._v("-")]
                                  ),
                                ]),
                              ]),
                              _c("ib-table-col", { attrs: { width: "9ch" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "border-bottom",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.sortResults(
                                          "sector",
                                          "",
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { title: _vm.$t("sector") } },
                                      [_vm._v(_vm._s(_vm.$t("sector")))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "up",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "sector" &&
                                            _vm.previousSort.dir === "asc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "sector",
                                              "asc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: { d: "M25 13L4 35h42z" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "down",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "sector" &&
                                            _vm.previousSort.dir === "desc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "sector",
                                              "desc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M4 17l21 22 21-22z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "weighted text-right" },
                                    [_vm._v("-")]
                                  ),
                                ]),
                              ]),
                              _c("ib-table-col", { attrs: { width: "8ch" } }, [
                                _c("div", { staticClass: "border-bottom" }, [
                                  _c(
                                    "span",
                                    { attrs: { title: _vm.$t("price") } },
                                    [_vm._v(_vm._s(_vm.$t("price")) + "*")]
                                  ),
                                ]),
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "weighted text-right" },
                                    [_vm._v("-")]
                                  ),
                                ]),
                              ]),
                              _c("ib-table-col", { attrs: { width: "10ch" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "border-bottom",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.sortResults(
                                          "mkt_cap",
                                          "",
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { title: _vm.$t("mkt_cap") } },
                                      [_vm._v(_vm._s(_vm.$t("mkt_cap")))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "up",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "mkt_cap" &&
                                            _vm.previousSort.dir === "asc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "mkt_cap",
                                              "asc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: { d: "M25 13L4 35h42z" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "down",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "mkt_cap" &&
                                            _vm.previousSort.dir === "desc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "mkt_cap",
                                              "desc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M4 17l21 22 21-22z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "fg-70 fg-primary text-right weighted",
                                    },
                                    [_vm._v(_vm._s(_vm.wGroupCaps[index]))]
                                  ),
                                ]),
                              ]),
                              _c("ib-table-col", { attrs: { width: "8ch" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "border-bottom",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.sortResults("ev", "", index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { title: _vm.$t("ev") } },
                                      [_vm._v(_vm._s(_vm.$t("ev")))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "up",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type === "ev" &&
                                            _vm.previousSort.dir === "asc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "ev",
                                              "asc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: { d: "M25 13L4 35h42z" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "down",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type === "ev" &&
                                            _vm.previousSort.dir === "desc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "ev",
                                              "desc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M4 17l21 22 21-22z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "fg-70 fg-primary text-right weighted",
                                    },
                                    [_vm._v(_vm._s(_vm.wGroupEVs[index]))]
                                  ),
                                ]),
                              ]),
                              _c("ib-table-col", { attrs: { width: "7ch" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "border-bottom",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.sortResults("rev", "", index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { title: _vm.$t("rev") } },
                                      [_vm._v(_vm._s(_vm.$t("rev")))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "up",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type === "rev" &&
                                            _vm.previousSort.dir === "asc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "rev",
                                              "asc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: { d: "M25 13L4 35h42z" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "down",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type === "rev" &&
                                            _vm.previousSort.dir === "desc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "rev",
                                              "desc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M4 17l21 22 21-22z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "fg-70 fg-primary text-right weighted",
                                    },
                                    [_vm._v(_vm._s(_vm.wGroupRevs[index]))]
                                  ),
                                ]),
                              ]),
                              _c("ib-table-col", { attrs: { width: "10ch" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "border-bottom",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.sortResults(
                                          "earnings",
                                          "",
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { title: _vm.$t("earnings") } },
                                      [_vm._v(_vm._s(_vm.$t("earnings")))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "up",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "earnings" &&
                                            _vm.previousSort.dir === "asc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "earnings",
                                              "asc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: { d: "M25 13L4 35h42z" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "down",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "earnings" &&
                                            _vm.previousSort.dir === "desc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "earnings",
                                              "desc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M4 17l21 22 21-22z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  parseFloat(_vm.wGroupEarnings[index]) > 0
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "fg-70 fg-primary text-right weighted",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.wGroupEarnings[index])
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "weighted text-right" },
                                        [_vm._v("-")]
                                      ),
                                ]),
                              ]),
                              _c("ib-table-col", { attrs: { width: "12ch" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "border-bottom",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.sortResults(
                                          "eps_growth",
                                          "",
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { title: _vm.$t("eps_growth") },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("eps_growth")) + " %"
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "up",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "eps_growth" &&
                                            _vm.previousSort.dir === "asc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "eps_growth",
                                              "asc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: { d: "M25 13L4 35h42z" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "down",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type ===
                                              "eps_growth" &&
                                            _vm.previousSort.dir === "desc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "eps_growth",
                                              "desc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M4 17l21 22 21-22z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "fg-70 fg-primary text-right weighted",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.wGroupEpsGrowth[index]) + "%"
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c("ib-table-col", { attrs: { width: "8ch" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "border-bottom",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.sortResults("div", "", index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { title: _vm.$t("div") } },
                                      [_vm._v(_vm._s(_vm.$t("div")) + " %")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "up",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type === "div" &&
                                            _vm.previousSort.dir === "asc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "div",
                                              "asc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: { d: "M25 13L4 35h42z" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "down",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type === "div" &&
                                            _vm.previousSort.dir === "desc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "div",
                                              "desc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M4 17l21 22 21-22z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  parseFloat(_vm.wGroupDY[index]) > 0
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "fg-70 fg-primary text-right weighted",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.wGroupDY[index]) + "%"
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "weighted text-right" },
                                        [_vm._v("-")]
                                      ),
                                ]),
                              ]),
                              _c("ib-table-col", { attrs: { width: "7ch" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "border-bottom",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.sortResults("pe", "", index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { title: _vm.$t("pe") } },
                                      [_vm._v(_vm._s(_vm.$t("pe")))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "up",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type === "pe" &&
                                            _vm.previousSort.dir === "asc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "pe",
                                              "asc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: { d: "M25 13L4 35h42z" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "down",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type === "pe" &&
                                            _vm.previousSort.dir === "desc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "pe",
                                              "desc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M4 17l21 22 21-22z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  parseFloat(_vm.wGroupPES[index]) > 0
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "fg-70 fg-primary text-right weighted",
                                        },
                                        [_vm._v(_vm._s(_vm.wGroupPES[index]))]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "weighted text-right" },
                                        [_vm._v("-")]
                                      ),
                                ]),
                              ]),
                              _c("ib-table-col", { attrs: { width: "7ch" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "border-bottom",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.sortResults("peg", "", index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { title: _vm.$t("peg") } },
                                      [_vm._v(_vm._s(_vm.$t("peg")))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "up",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type === "peg" &&
                                            _vm.previousSort.dir === "asc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "peg",
                                              "asc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: { d: "M25 13L4 35h42z" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "down",
                                        class: {
                                          "active-sort":
                                            _vm.previousSort.type === "peg" &&
                                            _vm.previousSort.dir === "desc" &&
                                            _vm.previousSort.index === index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.sortResults(
                                              "peg",
                                              "desc",
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M4 17l21 22 21-22z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  parseFloat(_vm.wGroupPEGS[index]) > 0
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "fg-70 fg-primary text-right weighted",
                                        },
                                        [_vm._v(_vm._s(_vm.wGroupPEGS[index]))]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "weighted text-right" },
                                        [_vm._v("-")]
                                      ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      }),
      _vm.picked !== null
        ? _c("InfoModal", {
            ref: "groupInfoModal",
            attrs: { picked: _vm.picked, type: _vm.type },
          })
        : _vm._e(),
      _c("DetailsModal", { ref: "detailInfo" }),
      _c(
        "ib-dialog",
        {
          ref: "modal",
          attrs: { autoclose: true },
          model: {
            value: _vm.showLoginScreen,
            callback: function ($$v) {
              _vm.showLoginScreen = $$v
            },
            expression: "showLoginScreen",
          },
        },
        [
          _c("div", { staticClass: "inner-modal" }, [
            _c("div", { staticClass: "add-info flex-fixed top" }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("login")))]),
              _c("a", { on: { click: _vm.closeModal } }, [
                _c("span", { staticClass: "fg" }, [
                  _c("svg", { attrs: { viewBox: "0 0 20 20" } }, [
                    _c("path", {
                      attrs: {
                        d: "M10 0a10 10 0 1010 10A10.029 10.029 0 0010 0z",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M14.9 13.5l-1.4 1.4-3.5-3.5-3.5 3.5-1.4-1.4L8.6 10 5.1 6.5l1.4-1.4L10 8.6l3.5-3.5 1.4 1.4-3.5 3.5z",
                        fill: "#fff",
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "modal-body" }, [
              _c("h5", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("login_to_portal"))),
              ]),
              _c(
                "p",
                { staticClass: "text-center" },
                [
                  _c(
                    "ib-button",
                    {
                      staticClass: "bg-accent _btn act",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.addFilters.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("have_existing_account")))]
                  ),
                ],
                1
              ),
              _c("br"),
              _c("h5", { staticClass: "text-center" }, [
                _vm._v(
                  _vm._s(_vm.$t("no_account")) +
                    " " +
                    _vm._s(_vm.$t("open_one"))
                ),
              ]),
              _c("p", { staticClass: "text-center after-16" }, [
                _c(
                  "a",
                  {
                    staticClass: "bg-accent _btn act",
                    attrs: {
                      href: "https://www.interactivebrokers.com/en/index.php?f=4695",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("open_ib_account")))]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }